import { useState } from "react";
import onClickOutside from "react-onclickoutside";
function Pointsdropdown({
  modelDropDownOptions,
  selectedOptions,
  setSelectedOptions,
  setModelCriteria,
  isSingleSelect
}) {
  const [isActive, setIsActive] = useState(false);

  Pointsdropdown.handleClickOutside = () => {
    setIsActive(false);
  };
  const handleOptionClick = (option) => {
    if (isSingleSelect) {
      selectedOptions = [];
    }
    if (selectedOptions?.includes(option)) {
      let setOptions = selectedOptions?.filter((selectedOption) => selectedOption !== option);
      setSelectedOptions(setOptions);
    } else {
      modelDropDownOptions.map(x => {
        if (x.model_name === option) {
          setModelCriteria(x);
        }
      });
      setSelectedOptions([...selectedOptions, option]);
    }
    setIsActive(false);
  };

  return (
    <div className="dropdown" style={{ position: "relative" }}>
      <div className="dropdown-btn" onClick={(e) => setIsActive(!isActive)}>
        {selectedOptions?.length > 0 && (
          <div style={{ display: 'inline-block', backgroundColor: '', padding: '5px' }}>
            {selectedOptions?.map((selectedOption) => (
              <span key={selectedOption} style={{ marginRight: '5px' }}>
                {selectedOption || 'Select'}
              </span>
            ))}
          </div>
        )}
        <span className="fas fa-caret-down"></span>
      </div>
      {isActive && (
        <select multiple={true} className="dropdown-content" style={{ zIndex: 300, maxHeight: "180px", overflowY: "auto" }} onChange={(event) => handleOptionClick(event.target.value)}>
          {modelDropDownOptions?.map((option) => (
            <option
              key={option.model_name}
              className="dropdown-item"
              value={option.model_name}
            >
              {option.model_name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
const clickOutsideConfig = {
  handleClickOutside: () => Pointsdropdown.handleClickOutside,
};

export default onClickOutside(Pointsdropdown, clickOutsideConfig);
